type Privilege = {
  name: string;
  description: string;
};

const privilege: Privilege = {
  name: "",
  description: "",
};

export type { Privilege };

export { privilege };
